import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MyDashboardState } from './my-dashboard.state';

export const myDashboardState = createFeatureSelector< MyDashboardState>('myDashboard');

export const showQuotesForAllBranches = createSelector(
  myDashboardState,
  (state) => state.showQuotesCountForAllBranches
);

export const getQuotesForBranchCode = createSelector(
  myDashboardState,
  (state) => state.branchCode
);

export const selectOpenItemCountRefreshTrigger = createSelector(
  myDashboardState,
  (state) => state.openItemCountRefreshTrigger
);
